// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"c85276ca","98":"754042a2","302":"f0df5b62","480":"ccfc8eda","613":"12f2fcb7","670":"47efd24d","672":"834526f2","676":"3c51fc4c","682":"a877ee75","790":"f69648fb","812":"4c43d928","848":"cc615c88","903":"1d3b5b05"}[chunkId] + ".chunk.js";
};